// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_nj-0";